
import React from 'react';
import { AccuracyTester } from '@/components/testing/AccuracyTester';

export default function TextAnalysisAccuracy() {
  return (
    <div className="container mx-auto py-8">
      <div className="mb-8">
        <h1 className="text-2xl font-bold tracking-tight">Text Analysis Accuracy Testing</h1>
        <p className="text-muted-foreground mt-2">
          Test the accuracy of the AI content detection system against various types of text samples.
        </p>
      </div>
      
      <AccuracyTester />
    </div>
  );
} 
